import React from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import adduserimage from "../../assets/landing_page/new/Add User-rafiki 1.svg";
import { useNavigate } from "react-router-dom";
function EmptyUser() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/home/adduser");
  };
  return (
    <div
      style={{
        border: "2px dotted #ccc",
        borderRadius: "8px",
        padding: "20px",
        textAlign: "center",
        margin: "0 auto",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // Center content vertically
        alignItems: "center", // Center content horizontally
      }}>
      <img
        src={adduserimage}
        alt='Placeholder'
        style={{
          width: "150px",
          height: "150px",
          objectFit: "cover",
          marginBottom: "16px",
        }}
      />
      <div
        style={{
          marginBottom: "16px",
          fontFamily: "Inter, sans-serif", // Include fallback font
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "16.94px",
          textAlign: "left",
        }}>
        Add your first internal user to kickstart your project.
      </div>
      <Button
        variant='contained'
        onClick={handleClick}
        sx={{
          fontFamily: "Inter, sans-serif",
          textTransform: "none",
          fontWeight: 500,
          backgroundColor: "#FF2800",
          padding: "6px 16px",
          "&:hover": {
            backgroundColor: "#FF2800",
          },
        }}
        startIcon={<AddIcon />}>
        Add User
      </Button>
    </div>
  );
}

export default EmptyUser;
